/*
 * FileName : index.tsx
 * ProjectName : admin
 * Author : terrorblade
 * Created Date: 2021-07-03 22:55:31
 * Description :
 * -----
 * Last Modified: 2024-03-22 17:11:35
 * Modified By :
 * -----
 * Copyright (c) 2021 Magina Corporation. All rights reserved.
 */
// eslint-disable-next-line no-use-before-define
import React from 'react';
import ReactDOM from 'react-dom';
import { Spin } from 'antd';

const showLoading = (id:string = '') => {
    const loading = document.getElementById(`${id}loading`) as HTMLElement;

    if (!loading) {
        const dom = document.createElement('div');

        dom.setAttribute('id', `${id}loading`);
        dom.setAttribute('class', 'element-loading');
        if (id) {
            document.getElementById(id)?.appendChild(dom);
        } else {
            document.body.appendChild(dom);
        }
        // eslint-disable-next-line react/no-deprecated
        ReactDOM.render(<Spin tip='loading...' size='large' />, dom);
    }
};

const hideLoading = (timeout = 0, id = '') => {
    setTimeout(() => {
        const loading = document.getElementById(`${id}loading`) as HTMLElement;

        if (loading) {
            if (id) {
                document.getElementById(id)?.removeChild(loading);
            } else {
                document.body.removeChild(loading);
            }
        }
    }, timeout);
};

export { showLoading, hideLoading };
